import classNames from 'classnames';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { CREATION_METHOD_TIMELINE } from 'constants/comments';
import { videoPlayerExitCommentMode } from 'creators/videoPlayer';
import { secondsToVideoTS } from 'utilities/time';

import CommentInputGroup from '../../comment-input-group';

import styles from './styles.module.less';

const CommentBar = () => {
  const dispatch = useDispatch();

  const onExitCommentMode = () => {
    dispatch(videoPlayerExitCommentMode());
  };

  const barClasses = classNames(styles.commentBar, 'theme-dark');
  const currentTime = useSelector(state => state.video_player.current_time);

  function submitButtonText() {
    return (
      <span>
        Comment at{' '}
        <span className={styles.timeText}>
          {secondsToVideoTS(Math.round(currentTime))}
        </span>
      </span>
    );
  }

  return (
    <div className={barClasses}>
      <CommentInputGroup
        allowOneLine={true}
        creationMethod={CREATION_METHOD_TIMELINE}
        drawCancel="true"
        grabFocus="true"
        inputSize="small"
        onCancel={onExitCommentMode}
        onSubmit={onExitCommentMode}
        placeholder="Leave a comment"
        submitButtonText={submitButtonText()}
      ></CommentInputGroup>
    </div>
  );
};

export default CommentBar;
